// SCR-012's routes (NAV-008 expense and CUR), composed into the route table by TASK-140.
import { defineRoute, type ScreenRoute } from "../../router/route";
import { EXPENSE_PATH, EXPENSE_PERIOD_PATH } from "./model";
import { Expense } from "./expense";
import { ExpensePeriodScreen } from "./finalize";

export const routes: ScreenRoute[] = [
  defineRoute({ nav: "NAV-008", path: EXPENSE_PATH, title: "AWS costs", permission: "billing:read", component: Expense }),
  defineRoute({
    nav: "NAV-008",
    path: EXPENSE_PERIOD_PATH,
    title: "AWS costs for a month",
    permission: "billing:read",
    component: ExpensePeriodScreen,
  }),
];
